import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
import $ from 'jquery';
const answer = [];
const c_answer = [];
class ISMSQuizList extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            user_Name: has_local_data ? localdata.user_name : '',
            userEmail: has_local_data ? localdata.user_email : '',
            qBank:[],
            questionArr:[],
            questionArray:[],
            countAnswer:0,
            object:[],
            answerArray:[],
            score:'',
            Answer:'',
            loading: 1,
            waiting: 1,
            questionTitle: ''
        };
        // this.onChange = this.onChange.bind(this);
        this.handleAnswerChange = this.handleAnswerChange.bind(this);
      }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
      return findresponse;
  }
    getUserDetail() {
      fetch(this.state.apiUrl + '/Elearning/GetUserDetail/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
      })
        .then((Response) => Response.json())
        .then((findresponse) => {
          findresponse = this.rawjsonparse(findresponse,1);
          //document.getElementById("quiz_Pass").className += "show";
          console.log(findresponse);
          this.setState({
            userName: findresponse.user_name,
            position: findresponse.position,
            attachment: findresponse.attachment,
            pass_score:findresponse.passing_score,
            valid_till_dt:findresponse.valid_till_date,

            quiz_start:findresponse.quiz_start,
            quiz_year: findresponse.quiz_year,
            quiz_title: findresponse.quiz_title
          })
          this.getScoreDetail();
        })
    }
    handleAnswerChange(e,question,correct_answer,choosen_answer){
      var object = {'question_seq':question, 'correct_answer': correct_answer, 'choosen_answer': choosen_answer};
      
      answer.forEach((element) => {
        if(element.question_seq == object.question_seq){
            const removeIndex = answer.findIndex( item => item.question_seq === object.question_seq);
            answer.splice( removeIndex, 1 );
        }
      });
      c_answer.forEach((e) => {
        if(e.question_seq == object.question_seq){
            const removeDuplicate = answer.findIndex( item => item.question_seq === object.question_seq);
            c_answer.splice( removeDuplicate, 1 );
        }
      });
      if(correct_answer==choosen_answer){
        c_answer.push(object);
      }
      answer.push(object);
    console.log(c_answer);
       this.setState({countAnswer:answer.length});
    }
    SaveQuiz() {
      const fd = new FormData;
      fd.append('answer', JSON.stringify(answer));
      fd.append('total_question', JSON.stringify(this.state.qBank.length));
      fd.append('deta', JSON.stringify(this.state));
      fetch(this.state.apiUrl + '/Elearning/SaveQuiz/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId , {
           method: 'POST',
           dataType: 'json',
           body: fd,
       })
          .then((Response) => Response.json())
          .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            this.getScoreDetail();
       })
    
      }
    getScoreDetail() {
      fetch(this.state.apiUrl + '/Elearning/GetScoreDetail/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
      })
        .then((Response) => Response.json())
        .then((findresponse) => {
          findresponse = this.rawjsonparse(findresponse,1);
          console.log(findresponse);
    let quizDetail = Object.entries(findresponse).length;
    console.log(quizDetail);
          this.setState({
             score:findresponse.final_score,
             status:findresponse.status,
             passing_score:findresponse.passing_score,
             attempted:findresponse.attempted,
             correct:findresponse.correct,
             valid_till_date:findresponse.valid_till_date,
             waiting: 0

          })
          if(quizDetail!=0 && this.state.status!=''){
            //window.$("#quiz_Pass").modal('show');
            if(this.state.status==1){
              window.$("#quiz_Pass").modal('show');
              window.$("#quiz_Fail").modal('hide');
            }else{
              window.$("#quiz_Fail").modal('show');
              window.$("#quiz_Pass").modal('hide');
            }
            document.body.classList.remove('modal-open');
          //   window.$('#quiz_Pass').modal({
          //     backdrop: 'static',
          //     keyboard: false
          // })
          }else{

          }
        })
    }
    questionList() {
      fetch(this.state.apiUrl + '/Elearning/GetQuestions/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(),
      })
        .then((Response) => Response.json())
        .then((findresponse) => {
          this.setState({
            qBank:findresponse.data[0].questions.question_list,
            questionTitle:findresponse.data[0].title,
            loading: 0,
          })

        })
    }
    getQuestionRows() {
        if (this.state.loading) {
            return (
              <div class="Qlisting">
                <ul class="list_questions">
                <div class="loader-new"></div>
                </ul>
              </div>
            )
        } else {
            return (
              <div>
                <div class="Qlisting"> 
                <ul class="list_questions">
                <form>
                {
                    this.state.qBank.map((result, index) =>
                  <li>
                    <div class="Qtitle"><span>Q{index+1}.</span>{result.question_name}</div>
                     
                    <div class="Qborder">
                        <div class="on_txt">answer choices</div>
                    </div>
                    {result.options.map((answer, i) =>
                    <div class="question_radio col-md-6 col-sm-6 col-xs-12 plr">
                      <input type="radio" id={`question${result.ques_seq}-${answer.option_seq}`} name={`question${result.ques_seq}`} onClick={(e) => this.handleAnswerChange(e,result.ques_seq,result.correct_answer,answer.option_seq)}/>
                      <label for={`question${result.ques_seq}-${answer.option_seq}`}>{answer.option_name}</label>
                    </div>
                    )}
                    
                  </li>
                    )}
                  
                  </form>
                  
              </ul>
              
          </div>
          {this.state.quiz_start == 1 ? <div class="col-md-12 plr float-right">
                <a href="#" class="btn btn-sky_new" onClick={() => this.SaveQuiz()} data-toggle="modal" data-target="#quiz_Pass">
                <span>View My Result <i class="far fa-arrow-right"></i></span>
                </a>
              </div> : ''}
              <div class="clear"></div>
              </div>
            )
        }
    }
    
    componentDidMount() {
        document.title = "Intranet | Quiz";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        
        this.getUserDetail();
        this.questionList();
    }

    render() {
        
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Employee" brecum_page={localStorage.getItem('quizTitle')} />
                <div class="right_col">
                  <div class="intranet_body">
                    <div class="title mob hidden-sm">
                         <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left"></i></div><span> {localStorage.getItem('quizTitle')}</span>
                           <div class="mob-search hidden-md pull-right"><i class="fa fa-search"></i><i class="fa fa-sliders" aria-hidden="true"></i></div>
                    </div>
                    <div class="quiz_area fixed-desig">
                      <div class="quiz_user-desig">
                        <div class="media">
                          <div class="media-left">
                            <div class="user_img">
                    {this.state.attachment ? <img src={this.state.attachment} /> : <span class="quiz_first_name">{this.state.user_Name.charAt(0).toUpperCase()}</span>}
                            </div>
                          </div>
                          <div class="media-body">
                            <div class="emp_name_designation">
                              <div class="emp_name">{this.state.user_Name}</div>
                                <ul class="desi_quiz_details">
                                  <li><span><i class="far fa-suitcase"></i></span>{this.state.position}</li>
                                  <li><span><i class="fa fa-certificate"></i></span>Passing Score : {this.state.pass_score}%</li>
                                  <li><span><i class="far fa-check-circle"></i></span>Last Date : {this.state.valid_till_dt}</li>
                                </ul>
                              </div>
                            </div>
                          </div>                 
                          </div>
                          <div class="question_no_progress">
                            <div class="col-md-6 col-sm-6 col-xs-6 plr">
                              <div class="question_no">Answered: <span>{this.state.countAnswer} of {this.state.qBank.length}</span></div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6 plr">
                            </div>
                          </div>
                          </div>
                          {this.getQuestionRows()}
                    </div>
                  
                    <div class="quiz">
                    {this.state.status==1 ?
                      <div class="modal fade in" id="quiz_Pass" href="#" tabindex="-1" data-backdrop="static" data-keyboard="false"role="dialog" aria-labelledby="quiz_Pass" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-dialog modal-md" role="document">
                          <div class="modal-content">
                            <div>
                            </div>
                            {this.state.waiting==1 ? <div class="modal-body"><div class="loader-new"></div></div> :
                            <div class="pass-modal-body">
                              <div class="scored">You scored {this.state.score}% ({this.state.correct} out of {this.state.qBank.length} Correct Answers)</div>
                              <div class="icon_txt">
                                <i class="fal fa-check-circle"></i>
                                Congratulations!
                                <span>You passed the {this.state.quiz_title}</span>
                              </div>
                              <div class="notification">Passing Score : {this.state.passing_score}% </div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      :
                      <div class="modal fade in" id="quiz_Fail" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="quiz_Failed" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-dialog modal-md" role="document">
                          <div class="modal-content">
                            <div>
                            </div>
                            {this.state.waiting==1 ? <div class="modal-body"><div class="loader-new"></div></div> :
                            <div class="modal-body">
                                <div class="scored">You scored {this.state.score}% ({this.state.correct} out of {this.state.qBank.length} Correct Answers)</div>
                                <div class="icon_txt_failed">
                                  <i class="fal fa-times-circle"></i>
                                  Sorry!
                                  <span>You failed the {this.state.quiz_title}</span>
                                  <div>
                                      <a href="#" class="btn btn-red" data-dismiss="modal">Try Again<i class="far fa-arrow-right"></i>
                                      </a>
                                  </div>
                                </div>
                                <div class="notification">Passing Score : {this.state.passing_score}% &nbsp;|&nbsp; Last Date : {this.state.valid_till_date}</div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
        )
    }
}
export default ISMSQuizList;


// WEBPACK FOOTER //
// ./src/components/ISMSQuiz/ISMSQuizList.js